import styled from "styled-components";

const HeaderTextContainer = styled.div`
  display: flex;
  align-items: center;
`;

const TableHeaderContainerStyled = styled.div`
  display: flex;
  background-color: ${(props) => (props.color ? `${props.color}` : "#9c27b0")};

  font-weight: bold;
  color: white;
`;
const TableHeaderColumnStyled = styled.div`
  justify-content: ${(props) =>
    props.position ? `${props.position}` : "center"};
  text-align: center;
  padding: 0.5rem 0.3rem;
  width: ${(props) => (props.width ? `${props.width}%` : "10%")};
`;
const TableBodyContainerStyled = styled.div`
  height: 550px;
`;

export {
  HeaderTextContainer,
  TableHeaderContainerStyled,
  TableBodyContainerStyled,
  TableHeaderColumnStyled,
};
